import { TestimonialProps } from './types';

export const defaultTestimonials: TestimonialProps = {
  cards: [
    {
      title:
        "I just keep saying it's dope. You can create complex designs very easily.",
      name: 'Rich Khun',
      subscribersText: '230k+ subscribers',
      image: {
        url: '/images/testimonials/testimonial1.png',
        width: 376,
        height: 573,
        filename: 'testimonial.png',
      },
    },
    {
      title: 'I’ve really enjoyed creating some stunning designs!',
      name: 'Will Paterson',
      subscribersText: '850k+ subscribers',
      image: {
        url: '/images/testimonials/testimonial2.png',
        width: 376,
        height: 573,
        filename: 'testimonial.png',
      },
    },
    {
      title: 'Kittl makes creating new designs super easy.',
      name: 'Odetta Rockhead-Kerr',
      subscribersText: '1.22M+ subscribers',
      image: {
        url: '/images/testimonials/testimonial3.png',
        width: 376,
        height: 573,
        filename: 'testimonial.png',
      },
    },
  ],
};
